// @mui material components
import { createTheme } from "@mui/material/styles";

import colors from "./base/colors";
import breakpoints from "./base/breakpoints";
import typography from "./base/typography";
import globals from "./base/globals";
import boxShadows from "./base/boxShadows";
import borders from "./base/borders";

import boxShadow from "./functions/boxShadow";
import hexToRgb from "./functions/hexToRgb";
import linearGradient from "./functions/linearGradient";
import pxToRem from "./functions/pxToRem";
import rgba from "./functions/rgba";

import sidenav from "./components/sidenav";
import list from "./components/list";
import listItem from "./components/list/listItem";
import listItemText from "./components/list/listItemText";
import card from "./components/card";
import cardMedia from "./components/card/cardMedia";
import cardContent from "./components/card/cardContent";
import button from "./components/button";
import chip from "./components/chip";
import iconButton from "./components/iconButton";
import input from "./components/form/input";
import inputLabel from "./components/form/inputLabel";
import inputOutlined from "./components/form/inputOutlined";
import textField from "./components/form/textField";
import datePickers from "./components/form/datePickers";
import menu from "./components/menu";
import menuItem from "./components/menu/menuItem";
import switchButton from "./components/form/switchButton";
import divider from "./components/divider";
import tableContainer from "./components/table/tableContainer";
import tableHead from "./components/table/tableHead";
import tableCell from "./components/table/tableCell";
import linearProgress from "./components/linearProgress";
import breadcrumbs from "./components/breadcrumbs";
import slider from "./components/slider";
import avatar from "./components/avatar";
import tooltip from "./components/tooltip";
import appBar from "./components/appBar";
import tabs from "./components/tabs";
import tab from "./components/tabs/tab";
import stepper from "./components/stepper";
import step from "./components/stepper/step";
import stepConnector from "./components/stepper/stepConnector";
import stepLabel from "./components/stepper/stepLabel";
import stepIcon from "./components/stepper/stepIcon";
import select from "./components/form/select";
import formControlLabel from "./components/form/formControlLabel";
import formLabel from "./components/form/formLabel";
import checkbox from "./components/form/checkbox";
import radio from "./components/form/radio";
import autocomplete from "./components/form/autocomplete";
import container from "./components/container";
import popover from "./components/popover";
import buttonBase from "./components/buttonBase";
import icon from "./components/icon";
import svgIcon from "./components/svgIcon";
import link from "./components/link";
import dialog from "./components/dialog";
import dialogTitle from "./components/dialog/dialogTitle";
import dialogContent from "./components/dialog/dialogContent";
import dialogContentText from "./components/dialog/dialogContentText";
import dialogActions from "./components/dialog/dialogActions";
import dataGrid from "./components/dataGrid";

export default createTheme({
  shape: { borderRadius: 16 },
  breakpoints: { ...breakpoints },
  palette: { mode: "light", ...colors } as any,
  typography: { ...typography } as any,
  boxShadows: { ...boxShadows },
  borders: { ...borders },
  functions: {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...container,
      },
    },
    MuiDrawer: { ...sidenav } as any,
    MuiList: { ...list } as any,
    MuiListItem: { ...listItem } as any,
    MuiListItemText: { ...listItemText } as any,
    MuiCard: { ...card } as any,
    MuiCardMedia: { ...cardMedia } as any,
    MuiCardContent: { ...cardContent } as any,
    MuiButton: { ...button } as any,
    MuiChip: { ...chip } as any,
    MuiIconButton: { ...iconButton } as any,
    MuiInput: { ...input } as any,
    MuiInputLabel: { ...inputLabel } as any,
    MuiOutlinedInput: { ...inputOutlined } as any,
    MuiFormControl: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
        },
      },
    } as any,
    MuiTextField: { ...textField } as any,
    MuiMenu: { ...menu } as any,
    MuiMenuItem: { ...menuItem } as any,
    MuiSwitch: { ...switchButton } as any,
    MuiDivider: { ...divider } as any,
    MuiTableContainer: { ...tableContainer } as any,
    MuiTableHead: { ...tableHead } as any,
    MuiTableCell: { ...tableCell } as any,
    MuiLinearProgress: { ...linearProgress } as any,
    MuiBreadcrumbs: { ...breadcrumbs } as any,
    MuiSlider: { ...slider } as any,
    MuiAvatar: { ...avatar } as any,
    MuiTooltip: { ...tooltip } as any,
    MuiAppBar: { ...appBar } as any,
    MuiTabs: { ...tabs } as any,
    MuiTab: { ...tab } as any,
    MuiStepper: { ...stepper } as any,
    MuiStep: { ...step } as any,
    MuiStepConnector: { ...stepConnector } as any,
    MuiStepLabel: { ...stepLabel } as any,
    MuiStepIcon: { ...stepIcon } as any,
    MuiSelect: { ...select } as any,
    MuiFormControlLabel: { ...formControlLabel } as any,
    MuiFormLabel: { ...formLabel } as any,
    MuiCheckbox: { ...checkbox } as any,
    MuiRadio: { ...radio } as any,
    MuiAutocomplete: { ...autocomplete } as any,
    MuiPopover: { ...popover } as any,
    MuiButtonBase: { ...buttonBase } as any,
    MuiIcon: { ...icon } as any,
    MuiSvgIcon: { ...svgIcon } as any,
    MuiLink: { ...link } as any,
    MuiDialog: { ...dialog } as any,
    MuiDialogTitle: { ...dialogTitle } as any,
    MuiDialogContent: { ...dialogContent } as any,
    MuiDialogContentText: { ...dialogContentText } as any,
    MuiDialogActions: { ...dialogActions } as any,
    MuiDataGrid: { ...dataGrid } as any,
    ...datePickers,
  },
} as any);
